export default __webpack_public_path__ + "static/media/orders-small.b248255e.svg";